import { z } from '@harvestiq/zod';
import { claimDocumentUploadSchema } from './upload-claim-document';
import { claimDocumentWithUploadUrlSchema } from './claim-document-with-upload-url';

export const uploadClaimDocumentRequestBodySchema =
  claimDocumentUploadSchema.omit({ orgId: true, uploadedBy: true });

export type UploadClaimDocumentRequestBody = z.infer<
  typeof uploadClaimDocumentRequestBodySchema
>;

export const uploadClaimDocumentResponseSchema = z.object({
  claimDocument: claimDocumentWithUploadUrlSchema,
});

export type UploadClaimDocumentResponse = z.infer<
  typeof uploadClaimDocumentResponseSchema
>;
